import { render, staticRenderFns } from "./attach-file.vue?vue&type=template&id=f0622dbc&scoped=true&"
import script from "./attach-file.vue?vue&type=script&lang=js&"
export * from "./attach-file.vue?vue&type=script&lang=js&"
import style0 from "./attach-file.vue?vue&type=style&index=0&id=f0622dbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0622dbc",
  null
  
)

export default component.exports